/**
 * Check for empty object
 * @param {Number} number
 * @returns {String}
 */
export const formatNumberInDollar = (number: number) => {
  if (!isNaN(Number(number))) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(number);
  } else return '';
};
